import React from 'react';
import { useParams } from 'react-router-dom';
import { LoadingOverlay } from '@mantine/core';
import useParkingService from '../hooks/parking-services/useParkingService.ts';
import ParkingRatePage from './ParkingRatePage.tsx';
import type { RegularRule, SpecificRule } from '../models/ParkingRate.ts';

const ParkingRateEditPage: React.FC = () => {
  const { serviceId, ruleType, ruleIndex } = useParams<{
    serviceId: string;
    ruleType: 'regular' | 'specific';
    ruleIndex: string;
  }>();

  const { data: service, isLoading } = useParkingService(serviceId!);

  if (isLoading || !service) return <LoadingOverlay visible={true} />;

  const idx = parseInt(ruleIndex!, 10);
  const initialRule =
    ruleType === 'regular'
      ? (service.parkingRate?.regularRules?.[idx] as RegularRule | undefined)
      : (service.parkingRate?.specificRules?.[idx] as SpecificRule | undefined);

  if (!initialRule) return <LoadingOverlay visible={true} />;

  return (
    <ParkingRatePage
      isEditMode={true}
      ruleTypeParam={ruleType as 'regular' | 'specific'}
      ruleIndex={idx}
      initialRule={initialRule}
    />
  );
};

export default ParkingRateEditPage;
